// extracted by mini-css-extract-plugin
module.exports = {"container":"_2o-jVojNsWSn4ek1zMj0y4","groupsList":"_3TRuD2MBrlK5mbzEW8kPPG"};